import React from "react";
import cx from "classnames";
import styles from "./TopTitleRow.module.css";

const TopTitleRow = ({ title }) => {
  return (
    <div
      className={cx(
        styles.container,
        "d-flex",
        "align-items-center",
        "justify-content-center"
      )}
    >
      <h2 className={cx(styles.title)}>{title}</h2>
    </div>
  );
};

export default TopTitleRow;
